document.addEventListener('DOMContentLoaded', function () {
  // FAQ Accordion
  document.querySelectorAll('.faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.parentElement;
      var isActive = item.classList.contains('active');
      document.querySelectorAll('.faq-item').forEach(function (el) { el.classList.remove('active'); });
      if (!isActive) item.classList.add('active');
    });
  });

  // Scroll Reveal
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) e.target.style.animationPlayState = 'running'; });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(function (el) { el.style.animationPlayState = 'paused'; observer.observe(el); });

  // Mobile Menu
  var menuBtn = document.getElementById('mobileMenuBtn');
  var mobileMenu = document.getElementById('mobileMenu');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function () {
      menuBtn.classList.toggle('active');
      mobileMenu.classList.toggle('open');
      document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
    });
    // Close on link click
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        menuBtn.classList.remove('active');
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  // Hero Carousel
  var slides = document.querySelectorAll('.carousel-slide');
  var indicators = document.querySelectorAll('.indicator');
  var counter = document.getElementById('carouselCurrent');
  if (slides.length > 0) {
    var current = 0, interval;
    function goTo(i) {
      slides[current].classList.remove('active');
      if (indicators[current]) indicators[current].classList.remove('active');
      current = i;
      slides[current].classList.add('active');
      if (indicators[current]) indicators[current].classList.add('active');
      if (counter) counter.textContent = String(current + 1).padStart(2, '0');
    }
    function next() { goTo((current + 1) % slides.length); }
    function prev() { goTo((current - 1 + slides.length) % slides.length); }
    function startAuto() { interval = setInterval(next, 3500); }
    function stopAuto() { clearInterval(interval); }

    indicators.forEach(function (ind) {
      ind.addEventListener('click', function () { stopAuto(); goTo(parseInt(this.dataset.index)); startAuto(); });
    });

    // Keyboard nav
    document.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { stopAuto(); next(); startAuto(); }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { stopAuto(); prev(); startAuto(); }
    });

    // Touch/Swipe support for mobile
    var carousel = document.getElementById('heroCarousel');
    if (carousel) {
      var touchStartX = 0, touchEndX = 0;
      carousel.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      carousel.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
          stopAuto();
          if (diff > 0) { next(); } else { prev(); }
          startAuto();
        }
      }, { passive: true });
    }

    startAuto();
  }
});
